import { useState } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import FormHelperText from "@mui/material/FormHelperText";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, itemSelected: readonly string[], theme: Theme) {
  return {
    fontWeight:
      itemSelected?.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectChip({
  label,
  name,
  error,
  keyToMap,
  value,
  formik,
  helperText,
  dataSourse,
  setItemSelected,
}: any) {
  const theme = useTheme();
  const [chipSelected, setChipSelected] = useState<string[]>([]);
  const handleChange = (event: SelectChangeEvent<typeof chipSelected>) => {
    const {
      target: { value },
    } = event;
    const elementKeys = typeof value === "string" ? value.split(",") : value;
    const elementObject = dataSourse.filter((item: any) => elementKeys.includes(item[keyToMap]));
    setChipSelected(elementKeys);
    setItemSelected(elementObject);
  };

  return (
    <div>
      <FormControl sx={{ mt: 2 }} fullWidth required error={error}>
        <InputLabel id='demo-multiple-chip-label' sx={{ color: "text.disabled" }}>
          {label}
        </InputLabel>
        <Select
          multiple
          name={name}
          value={value}
          id={name}
          labelId='demo-multiple-chip-label'
          onChange={(selectedOption: any) => {
            handleChange(selectedOption);
            formik.handleChange(selectedOption);
          }}
          input={<OutlinedInput id='select-multiple-chip' label={label} color='primary' />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected?.map((value: any) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {dataSourse?.map((item: any) => (
            <MenuItem
              key={item[keyToMap]}
              value={item[keyToMap]}
              style={getStyles(item[keyToMap], chipSelected, theme)}
            >
              {item[keyToMap]}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
}
